import { Button, Icon, Logo, Text } from '@devfolioco/genesis';
import { withRouter } from 'react-router';
import React from 'react';

import * as S from '../style';

class Header extends React.PureComponent {
  goBack = () => {
    const { history, quizId } = this.props;

    history.push({
      pathname: `/quiz/start`,
      state: { quizId },
    });
  };

  render() {
    const { sample } = this.props;

    return (
      <S.HeaderContainer sample={sample}>
        {sample && (
          <Button appearance="link" onClick={this.goBack} style={{ marginLeft: -24, marginBottom: 48 }}>
            <Icon name="chevron-left" />
            <span style={{ marginLeft: 8 }}>Go back</span>
          </Button>
        )}

        <Logo />

        {sample && (
          <Text size={48} weight="extrabold" upgrade style={{ marginTop: 12 }}>
            Sample quiz.
          </Text>
        )}
      </S.HeaderContainer>
    );
  }
}

export default withRouter(Header);
